module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVEhL7ZLBDcIwDEUzANPAEEiwBZduBEiMA0emgC6AOHKA/1EsWWlKHMUVlz7pqU6U2EnjMFPDFvbwbZDrNrCKO8wlG/MGq8glKUn4Nd0o3WyRSFy8kd5oleTmT3BAbmFJIvGkN2Dy9Xf0g8m7iF1gLWI68V9ZQX3iK1zG+AKbOUBdoIP7GJ9hEwv4gJL8Gefc2EFJTo/QFf5jXYDv4coL6gLU5WGFNLnoBrskTd7cOTMjhPAB+EGp4HFiRV0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-drill/dark/24.png
// module id = 1998
// module chunks = 2